{
  "type": "default_context_map",
  "extraState": {
    "itemCount": 9,
    "targets": [
      [
        "*.language"
      ],
      [
        "COMPOSITION.territory"
      ],
      [
        "*.encoding"
      ],
      [
        "*.start_time"
      ],
      [
        "*.origin"
      ],
      [
        "*.time"
      ],
      [
        "COMPOSITION.composer"
      ],
      [
        "EVENT_CONTEXT.health_care_facility"
      ],
      [
        "*.subject"
      ]
    ]
  },
  "fields": {
    "KEY0": "language",
    "TARGETS0": "[\"*.language\"]",
    "KEY1": "territory",
    "TARGETS1": "[\"COMPOSITION.territory\"]",
    "KEY2": "encoding",
    "TARGETS2": "[\"*.encoding\"]",
    "KEY3": "start_time",
    "TARGETS3": "[\"*.start_time\"]",
    "KEY4": "origin",
    "TARGETS4": "[\"*.origin\"]",
    "KEY5": "time",
    "TARGETS5": "[\"*.time\"]",
    "KEY6": "composer",
    "TARGETS6": "[\"COMPOSITION.composer\"]",
    "KEY7": "facility",
    "TARGETS7": "[\"EVENT_CONTEXT.health_care_facility\"]",
    "KEY8": "subject",
    "TARGETS8": "[\"*.subject\"]"
  },
  "inputs": {
    "VAL0": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "en"
        }
      },
      "block": {
        "type": "term_pick",
        "fields": {
          "NAME": "built-in",
          "SET": "ISO_639-1",
          "CODE": "sv",
          "SLOT_ID": "",
          "RM_TYPE": "CODE_PHRASE",
          "MANDATORY": ""
        }
      }
    },
    "VAL1": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "SE"
        }
      },
      "block": {
        "type": "term_pick",
        "fields": {
          "NAME": "built-in",
          "SET": "ISO_3166-1",
          "CODE": "SE",
          "SLOT_ID": "",
          "RM_TYPE": "CODE_PHRASE",
          "MANDATORY": ""
        }
      }
    },
    "VAL2": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "UTF-8"
        }
      },
      "block": {
        "type": "term_pick",
        "fields": {
          "NAME": "built-in",
          "SET": "IANA_character-sets",
          "CODE": "UTF-8",
          "SLOT_ID": "",
          "RM_TYPE": "CODE_PHRASE",
          "MANDATORY": ""
        }
      }
    },
    "VAL3": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "2026-08-01T09:13:58+02:00"
        }
      }
    },
    "VAL4": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "2026-08-01T09:13:58+02:00"
        }
      }
    },
    "VAL5": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "2026-08-01T09:13:58+02:00"
        }
      }
    },
    "VAL6": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "Dr. Who Demo"
        }
      },
      "block": {
        "type": "party_identified",
        "extraState": {
          "extras": [],
          "attrs": [
            "external_ref",
            "identifiers",
            "name"
          ],
          "rmType": "PARTY_IDENTIFIED",
          "prohibited": [],
          "slotCards": {},
          "rmCards": {}
        },
        "fields": {
          "NAME": "",
          "SLOT_ID": "",
          "RM_TYPE": "PARTY_IDENTIFIED",
          "MANDATORY": "",
          "ARCHETYPE_NODE_ID": "",
          "ARCHETYPE_CTX": ""
        },
        "inputs": {
          "ATTR_identifiers": {
            "block": {
              "type": "lists_create_with",
              "extraState": {
                "itemCount": 1
              },
              "inputs": {
                "ADD0": {
                  "block": {
                    "type": "dv_identifier",
                    "extraState": {
                      "fields": [
                        "issuer",
                        "assigner",
                        "type"
                      ]
                    },
                    "fields": {
                      "NAME": "Identifier",
                      "SLOT_ID": "",
                      "RM_TYPE": "DV_IDENTIFIER",
                      "MANDATORY": ""
                    },
                    "inputs": {
                      "FLD_id": {
                        "block": {
                          "type": "text",
                          "fields": {
                            "TEXT": "9876543210"
                          }
                        }
                      },
                      "OPTFLD_issuer": {
                        "block": {
                          "type": "text",
                          "fields": {
                            "TEXT": "General Medical Council"
                          }
                        }
                      },
                      "OPTFLD_assigner": {
                        "block": {
                          "type": "text",
                          "fields": {
                            "TEXT": "GMC"
                          }
                        }
                      },
                      "OPTFLD_type": {
                        "block": {
                          "type": "text",
                          "fields": {
                            "TEXT": "Professional Registration Number"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          "ATTR_name": {
            "block": {
              "type": "text",
              "fields": {
                "TEXT": "Dr. Who Demo"
              }
            }
          }
        }
      }
    },
    "VAL7": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": "St. Dummy Demo Hospital"
        }
      },
      "block": {
        "type": "party_identified",
        "extraState": {
          "extras": [],
          "attrs": [
            "name",
            "identifiers",
            "external_ref"
          ],
          "rmType": "PARTY_IDENTIFIED",
          "prohibited": [],
          "slotCards": {},
          "rmCards": {}
        },
        "fields": {
          "NAME": "",
          "SLOT_ID": "",
          "RM_TYPE": "PARTY_IDENTIFIED",
          "MANDATORY": "",
          "ARCHETYPE_NODE_ID": "",
          "ARCHETYPE_CTX": ""
        },
        "inputs": {
          "ATTR_name": {
            "block": {
              "type": "text",
              "fields": {
                "TEXT": "St. Dummy Demo Hospital"
              }
            }
          }
        }
      }
    },
    "VAL8": {
      "shadow": {
        "type": "text",
        "fields": {
          "TEXT": ""
        }
      },
      "block": {
        "type": "party_self",
        "extraState": {
          "extras": [],
          "attrs": [],
          "rmType": "PARTY_SELF",
          "prohibited": [],
          "slotCards": {},
          "rmCards": {}
        },
        "fields": {
          "NAME": "",
          "SLOT_ID": "",
          "RM_TYPE": "PARTY_SELF",
          "MANDATORY": "",
          "ARCHETYPE_NODE_ID": "",
          "ARCHETYPE_CTX": ""
        }
      }
    }
  }
}
